export default {
    root: ({props}) => ({
        class: [
            {
                "flex flex-wrap items-center justify-start gap-2": props.mode === "basic",
            },
        ],
    }),
    input: {
        class: "hidden",
    },
    header: {
        class: [
            // Flexbox
            "flex",
            "flex-wrap",

            // Colors
            "bg-stone-50",
            "dark:bg-stone-800",
            "text-stone-700",
            "dark:text-white/80",

            // Spacing
            "p-5",
            "gap-2",

            // Borders
            "border",
            "border-solid",
            "border-stone-200",
            "dark:border-stone-700",
            "border-b-0",

            // Shape
            "rounded-tr-lg",
            "rounded-tl-lg",
        ],
    },
    content: {
        class: [
            // Position
            "relative",

            // Colors
            "bg-stone-50",
            "dark:bg-stone-900",
            "text-stone-700",
            "dark:text-white/80",

            // Spacing
            "p-8",

            // Borders
            "border",
            "border-stone-200",
            "dark:border-stone-700",

            // Shape
            "rounded-b-lg",

            //ProgressBar
            "[&>[data-pc-name=pcprogressbar]]:absolute",
            "[&>[data-pc-name=pcprogressbar]]:w-full",
            "[&>[data-pc-name=pcprogressbar]]:top-0",
            "[&>[data-pc-name=pcprogressbar]]:left-0",
            "[&>[data-pc-name=pcprogressbar]]:h-1",
        ],
    },
    file: {
        class: [
            // Flexbox
            "flex",
            "items-center",
            "flex-wrap",

            // Spacing
            "p-4",
            "mb-2",
            "last:mb-0",

            // Borders
            "border",
            "border-stone-200",
            "dark:border-stone-700",
            "gap-2",

            // Shape
            "rounded",
        ],
    },
    fileThumbnail: "shrink-0 aspect-square min-w-28 flex justify-center items-center rounded-md dark:bg-stone-700",
    fileName: "mb-2 break-all grow",
    fileSize: "mr-2",
    fileinfo: "grow",
    pcChooseButton: {
        root: {
            class: [
                // Flexbox
                "flex",
                "items-center",
                "justify-center",

                // Colors
                "bg-askr-green-500",
                "text-white",
                "hover:brightness-110",
                "transition",
                "duration-200",

                // Spacing
                "px-2",
                "py-1.5",
                "gap-2",

                // Borders
                "border",
                "border-stone-200",
                "dark:border-stone-700",
                "rounded-lg",
            ],
        },
    },
    pcUploadButton: {
        root: ({attrs}) => {
            return {
                class: [
                    // Flexbox
                    "flex",
                    "items-center",
                    "justify-center",

                    // Colors
                    "bg-stone-200",
                    "text-black",
                    "transition",
                    "duration-200",
                    {"hover:brightness-90": !attrs.disabled},
                    {"opacity-50": attrs.disabled},

                    // Spacing
                    "px-2",
                    "py-1.5",
                    "gap-2",

                    // Borders
                    "rounded-lg",
                ],
            };
        },
    },
    pcCancelButton: {
        root: ({attrs}) => {
            return {
                class: [
                    // Flexbox
                    "flex",
                    "items-center",
                    "justify-center",

                    // Colors
                    "bg-stone-200",
                    "text-black",
                    "transition",
                    "duration-200",
                    {"hover:brightness-90": !attrs.disabled},
                    {"opacity-50": attrs.disabled},

                    // Spacing
                    "px-2",
                    "py-1.5",
                    "gap-2",

                    // Borders
                    "rounded-lg",
                ],
            };
        },
    },
};
